import { render, staticRenderFns } from "./DashBoardCallUser.vue?vue&type=template&id=143c6cb3&scoped=true"
import script from "./DashBoardCallUser.vue?vue&type=script&lang=js"
export * from "./DashBoardCallUser.vue?vue&type=script&lang=js"
import style0 from "./DashBoardCallUser.vue?vue&type=style&index=0&id=143c6cb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143c6cb3",
  null
  
)

export default component.exports